import React from "react";
import Modal from "@mui/material/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

const Loader = ({ middle }) => {
  const matches = useMediaQuery("(min-width:1024px)");
  const style = {
    position: "absolute",
    top: "50%",
    left: matches ? (middle ? "50%" : "calc(50% + 125px)") : "50%",
    transform: "translate(-50%, -50%)",
    p: 4,
    outline: "none",
  };
  return (
    <Modal
      open={true}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <CircularProgress />
      </Box>
    </Modal>
  );
};

export default Loader;
